import {
  IonContent,
  IonPage,
  IonCard,
  IonCardHeader,
  IonCardTitle,
  IonCardContent,
  IonButton,
  IonList,
  IonItem,
  IonLabel,
  IonSpinner,
  IonRefresher,
  IonRefresherContent,
  RefresherEventDetail,
} from '@ionic/react';
import { useNavigate } from 'react-router-dom';
import { useWallet } from '../contexts/WalletContext';
import { useLevel } from '../contexts/LevelContext';
import AppHeader from '../components/AppHeader';
import BottomNav from '../components/BottomNav';
import { format } from 'date-fns';
import './Wallet.css';

const Wallet: React.FC = () => {
  const navigate = useNavigate();
  const { balance, transactions, loading, refreshBalance, fetchTransactions } = useWallet();
  const { level } = useLevel();
  const currentLevel = level || 1; // Fallback to Level 1 while loading

  const handleRefresh = async (event: CustomEvent<RefresherEventDetail>) => {
    await Promise.all([refreshBalance(), fetchTransactions()]);
    event.detail.complete();
  };

  const formatDate = (date: Date) => {
    try {
      return format(date, 'MMM d, yyyy h:mm a');
    } catch {
      return date.toLocaleString();
    }
  };

  return (
    <IonPage>
      <AppHeader title="My Wallet" showBackButton={false} />
      <IonContent fullscreen className="ion-padding">
        <IonRefresher slot="fixed" onIonRefresh={handleRefresh}>
          <IonRefresherContent></IonRefresherContent>
        </IonRefresher>

        <div className="wallet-container">
          {loading ? (
            <div style={{ display: 'flex', justifyContent: 'center', padding: '2rem' }}>
              <IonSpinner name="crescent" />
            </div>
          ) : (
            <>
              {/* Balance Card */}
              <IonCard className="balance-card">
                <IonCardContent>
                  <div className="balance-display">
                    <span className="coin-icon">🪙</span>
                    <span className="balance-amount">{balance.toLocaleString()}</span>
                  </div>
                </IonCardContent>
              </IonCard>

              {/* Action Buttons */}
              <IonCard>
                <IonCardContent>
                  <div className="wallet-actions">
                    <IonButton
                      expand="block"
                      color="primary"
                      onClick={() => navigate('/games')}
                    >
                      Earn More Coins
                    </IonButton>
                <IonButton
                  expand="block"
                  fill="outline"
                  color="medium"
                  disabled={true}
                  style={{ opacity: 0.5, cursor: 'not-allowed' }}
                  title="Coming Soon - Coin redemption will be available in a future update"
                >
                  Redeem Gift Cards (Coming Soon)
                </IonButton>
                {currentLevel >= 2 && (
                  <IonButton
                    expand="block"
                    fill="outline"
                    color="medium"
                    disabled={true}
                    style={{ marginTop: '0.75rem', opacity: 0.5, cursor: 'not-allowed' }}
                    title="Coming Soon - Payment setup will be available in a future update"
                  >
                    Setup Payment Info (Coming Soon)
                  </IonButton>
                )}
                  </div>
                </IonCardContent>
              </IonCard>

              {/* Transaction History */}
              <IonCard className="transactions-card">
                <IonCardHeader>
                  <IonCardTitle>Transaction History</IonCardTitle>
                </IonCardHeader>
                <IonCardContent>
                  {transactions.length === 0 ? (
                    <div style={{ textAlign: 'center', padding: '3rem 2rem' }}>
                      <p style={{ color: 'var(--ion-text-color-step-600)', margin: 0, fontSize: '0.95rem' }}>
                        No transactions yet. Start earning coins!
                      </p>
                    </div>
                  ) : (
                    <IonList className="transactions-list">
                      {transactions.map((transaction, index) => (
                        <IonItem 
                          key={transaction.id}
                          className={`transaction-item ${index % 2 === 0 ? 'even' : 'odd'}`}
                        >
                          <IonLabel>
                            <h2>{transaction.description}</h2>
                            <p>{formatDate(transaction.timestamp)}</p>
                          </IonLabel>
                          <span
                            className={`transaction-amount ${
                              transaction.amount > 0 ? 'positive' : 'negative'
                            }`}
                            slot="end"
                          >
                            {transaction.amount > 0 ? '+' : ''}
                            {transaction.amount}
                          </span>
                        </IonItem>
                      ))}
                    </IonList>
                  )}
                </IonCardContent>
              </IonCard>
            </>
          )}
        </div>
      </IonContent>
      <BottomNav />
    </IonPage>
  );
};

export default Wallet;

